/* src/components/ResetPassword.js - v1.0 - Full Feature Reset */
import React, { useState, useEffect } from 'react';

function ResetPassword({ onComplete, backgroundStyle }) {
  const [token, setToken] = useState('');
  const [username, setUsername] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  // 1. Get Token & Verify on Mount
  useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const t = urlParams.get('token');
      setToken(t);

      if (!t) {
          setError("No token provided.");
          setLoading(false);
          return;
      }

      // Verify Token with Backend
      fetch('/api/reset-password/verify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: t })
      })
      .then(res => res.json())
      .then(data => {
          if (data.valid) {
              setUsername(data.username);
          } else {
              setError("Link expired or invalid.");
          }
      })
      .catch(() => setError("Connection error."))
      .finally(() => setLoading(false));
  }, []);

  const handleReset = async (e) => {
      e.preventDefault();
      if (newPassword !== confirmPassword) return alert("Passwords do not match!");
      if (newPassword.length < 3) return alert("Password too short!");

      try {
          const res = await fetch('/api/reset-password', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ token, password: newPassword })
          });
          const data = await res.json();
          
          if (res.ok) {
              alert("Password changed! Please log in.");
              onComplete(); // Go to Login
          } else {
              alert(data.error || "Failed to reset.");
          }
      } catch (err) { console.error(err); }
  };

  return (
    <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', ...backgroundStyle }}>
      <div className="card" style={{ width: '100%', maxWidth: '400px', padding: '40px', textAlign: 'center' }}>
        
        <h2 style={{ marginBottom: '20px' }}>Reset Password</h2>

        {loading && <p>Verifying link...</p>}

        {error && (
            <div>
                <p style={{ color: '#ff4757', marginBottom: '20px' }}>{error}</p>
                <button onClick={onComplete} className="action-btn">Return to Login</button>
            </div>
        )}

        {!loading && !error && username && (
            <form onSubmit={handleReset} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <p style={{ color: '#aaa', fontSize: '0.9rem', marginBottom: '10px' }}>
                    Setting new password for: <strong style={{ color: 'white' }}>{username}</strong>
                </p>
                
                <input 
                    type="password" 
                    className="post-input" 
                    placeholder="New Password" 
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                />
                <input 
                    type="password" 
                    className="post-input" 
                    placeholder="Confirm Password" 
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                />
                
                <button type="submit" style={{ marginTop: '10px', padding: '12px', background: '#2ed573', color: 'white', border: 'none', borderRadius: '5px', fontWeight: 'bold', cursor: 'pointer' }}>
                    Update Password
                </button>
                
                <button type="button" onClick={onComplete} style={{ background: 'transparent', border: 'none', color: '#aaa', cursor: 'pointer', marginTop: '10px' }}>
                    Cancel
                </button>
            </form>
        )}
      </div>
    </div>
  );
}

export default ResetPassword;
